import { Button } from "@/components/ui/button";
import { FileText, Save, Loader2, Mail, Truck } from "lucide-react";

// Bottom actions row: RFP, customer quote, save, driver route sheet, sent-RFP log.
export const QuoteActions = ({ onRfp, onQuoteDoc, onSave, saving, onDriver, onRfpLog }) => (
  <section className="flex flex-wrap gap-3 pb-10">
    <Button
      onClick={onRfp}
      className="bg-[#F97316] hover:bg-[#EA580C] text-white font-bold"
      data-testid="generate-rfp-button"
    >
      <FileText className="h-4 w-4 mr-2" /> Generate RFP
    </Button>
    <Button
      onClick={onQuoteDoc}
      variant="outline"
      className="border-[#F97316]/50 text-[#EA580C] hover:bg-[#FFF7ED] font-bold"
      data-testid="customer-quote-button"
    >
      <FileText className="h-4 w-4 mr-2" /> Customer Quote
    </Button>
    <Button
      onClick={onSave}
      disabled={saving}
      variant="outline"
      className="border-[#1C1917]/30 font-bold"
      data-testid="save-quote-button"
    >
      {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Save className="h-4 w-4 mr-2" />}
      Save Quote
    </Button>
    <Button
      onClick={onDriver}
      variant="outline"
      className="border-[#1C1917]/30 font-bold"
      data-testid="send-driver-button"
    >
      <Truck className="h-4 w-4 mr-2" /> Send to Driver
    </Button>
    <Button
      onClick={onRfpLog}
      variant="outline"
      className="border-[#1C1917]/30 font-bold"
      data-testid="rfp-log-button"
    >
      <Mail className="h-4 w-4 mr-2" /> Sent RFPs
    </Button>
  </section>
);
